// extracted by mini-css-extract-plugin
export default {"wrapper":"OnboardingTaskList_wrapper__2YmU0","videoWrapper":"OnboardingTaskList_videoWrapper__U3wOA","taskText":"OnboardingTaskList_taskText__89qba"};